import { useState } from 'react';
import { Dialog, Pane, Text, Alert } from 'evergreen-ui';
import { needsNightTail } from './duplicateShift';
import { isOvernightShift } from './overnightSplit';

const fmtDate = (iso) => (iso ? iso.split('-').reverse().slice(0, 2).join('/') : '');
const fmtTime = (t) => (t ? t.substring(0, 5) : '?');

export default function TurniDuplicateDialog({ pendingDuplicate, turniData, onClose, onConfirm }) {
  const { shift, targetDate } = pendingDuplicate || {};
  const hasOverlap = !!shift && turniData.some(t => t.date === targetDate && t.operator_name === shift.operator_name);
  const [isSaving, setIsSaving] = useState(false);

  // Blocca il doppio clic su "Duplica" finché il salvataggio non è concluso
  const handleConfirm = async (close) => {
    setIsSaving(true);
    try { await onConfirm(close); } finally { setIsSaving(false); }
  };

  return (
    <Dialog
      isShown={!!pendingDuplicate} title="Duplicare il turno?" width={420}
      onCloseComplete={onClose} onConfirm={handleConfirm} isConfirmLoading={isSaving}
      confirmLabel="Duplica" cancelLabel="Annulla"
    >
      {shift && (
        <Pane>
          <Text>
            Vuoi duplicare il turno di <strong>{shift.operator_name}</strong> ({fmtTime(shift.start_time)} / {fmtTime(shift.end_time)})
            del <strong>{fmtDate(shift.date)}</strong> al <strong>{fmtDate(targetDate)}</strong>?
          </Text>
          {(needsNightTail(shift) || isOvernightShift(shift)) && (
            <Text display="block" marginTop={12} size={300} color="muted">
              Verrà copiata anche la coda della notte sul giorno successivo.
            </Text>
          )}
          {hasOverlap && (
            <Alert intent="warning" marginTop={16} title={`${shift.operator_name} ha già un turno il ${fmtDate(targetDate)}`} />
          )}
        </Pane>
      )}
    </Dialog>
  );
}
